import * as React from 'react';

import './link.css';

interface LinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  size?: 'small' | 'medium' | 'large';
}

const Link = React.forwardRef<HTMLAnchorElement, LinkProps>(
  ({ size = 'small', children, ...props }, ref) => {
    if (!children) return;

    return (
      <a className={`link link-${size}`} ref={ref} {...props}>
        {children}
        <span className="link-underline" />
      </a>
    );
  },
);

export { Link };
